"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PunchWorkflow = void 0;
const react_1 = __importStar(require("react"));
const luxon_1 = require("luxon");
const View_1 = require("@amzn/atoz-web/View");
const Card_1 = require("@amzn/atoz-web/Card");
const Theme_1 = require("@amzn/atoz-web/Theme");
const PunchWorkflowTypes_1 = require("./PunchWorkflowTypes");
const BIAnalytics_1 = __importDefault(require("../../utils/BIAnalytics/BIAnalytics"));
const Shared_1 = require("../../components/Shared");
const ErrorPerson_web_1 = require("../../components/Shared/ErrorPerson/ErrorPerson.web");
const consts_1 = require("../../consts");
const logger_1 = require("../../logger");
const taaConfigs_1 = require("../../contexts/taaConfigs");
const context_1 = require("./context");
const PunchWorkflowConfig_1 = require("./PunchWorkflowConfig");
const utils_1 = require("../../utils");
const hooks_1 = require("./hooks");
const PunchWorkflow = ({ selectedDateTime: selectedDateTimeProps = luxon_1.DateTime.now(), associateInfo, featureGates }) => {
    const { clientName } = (0, taaConfigs_1.useTaaConfigsContext)();
    const dimensions = {
        ClientName: clientName,
        ClientType: logger_1.ClientType.WEB,
        usageLocation: consts_1.featureNames.PUNCH_WORKFLOW_FEATURE
    };
    const [currentStepTitle, setCurrentStepTitle] = (0, react_1.useState)('');
    const [currentStep, setCurrentStep] = (0, react_1.useState)(1);
    const [totalSteps, setTotalSteps] = (0, react_1.useState)(5);
    const [isActionable, setIsActionable] = (0, react_1.useState)(true);
    const [selectedDateTime, setSelectedDateTime] = (0, react_1.useState)(selectedDateTimeProps);
    const [selectedPunchList, setSelectedPunchList] = (0, react_1.useState)([]);
    const [action, setAction] = (0, react_1.useState)();
    const [selectedPunchTime, setSelectedPunchTime] = (0, react_1.useState)();
    const [newPunchTime, setNewPunchTime] = (0, react_1.useState)();
    const [newPunchDate, setNewPunchDate] = (0, react_1.useState)();
    const [useMilitaryTime, setUseMilitaryTime] = (0, react_1.useState)();
    const [addPunchLockedOutStatus, setAddPunchLockedOutStatus] = (0, react_1.useState)();
    const [editPunchLockoutStatus, setEditPunchLockoutStatus] = (0, react_1.useState)();
    const [isCurrentStepValid, setIsCurrentStepValid] = (0, react_1.useState)(true);
    const [showErrorFallback, setShowErrorFallback] = (0, react_1.useState)(false);
    const [payPeriodBreakdownInfo, setPayPeriodBreakdownInfo] = (0, react_1.useState)();
    const [punchesForMealLockoutValdn, setPunchesForMealLockoutValdn] = (0, react_1.useState)();
    const [isShowSummary, setIsShowSummary] = (0, react_1.useState)(false);
    const { setIsSubmitting, isSubmitting, submitPunch, deletePunch, editPunch, status, title: summaryTitle, supportingText, detailsTitle, detailsSubText, detailsNote } = (0, hooks_1.useSubmitWorkflow)({
        associateInfo,
        featureGates,
        action,
        inEditPunch: selectedPunchTime === null || selectedPunchTime === void 0 ? void 0 : selectedPunchTime.punchDateTime.timestamp,
        setIsShowSummary
    });
    (0, react_1.useEffect)(() => {
        if (isShowSummary) {
            BIAnalytics_1.default.arriveSummaryInPW();
        }
    }, [isShowSummary]);
    const onSubmit = () => {
        BIAnalytics_1.default.submitPunchWorkflow();
        setIsSubmitting(true);
        const isHistorical = (0, utils_1.isPunchHistorical)(newPunchDate, payPeriodBreakdownInfo);
        let metricName = null;
        if (action === PunchWorkflowTypes_1.PUNCH_WORKFLOW_ACTIONS.ADD) {
            metricName = logger_1.METRICS.PUNCH_WORKFLOW_SUBMIT_MISS_PUNCH.COUNT;
            submitPunch(newPunchTime, newPunchDate, useMilitaryTime, isHistorical);
        }
        if (action === PunchWorkflowTypes_1.PUNCH_WORKFLOW_ACTIONS.EDIT) {
            metricName = logger_1.METRICS.PUNCH_WORKFLOW_SUBMIT_EDIT_PUNCH.COUNT;
            editPunch(selectedPunchTime.punchDateTime, newPunchTime, newPunchDate, useMilitaryTime, isHistorical, punchesForMealLockoutValdn);
        }
        if (action === PunchWorkflowTypes_1.PUNCH_WORKFLOW_ACTIONS.DELETE) {
            metricName = logger_1.METRICS.PUNCH_WORKFLOW_SUBMIT_DELETE_PUNCH.COUNT;
            deletePunch(selectedPunchTime.punchDateTime.timestamp);
        }
        logger_1.logger.emitCountMetric({
            metricName,
            dimensions
        });
    };
    const onClose = () => {
        logger_1.logger.emitCountMetric({
            metricName: logger_1.METRICS.PUNCH_WORKFLOW_CLOSE_BUTTON_CLICK.COUNT,
            dimensions
        });
        BIAnalytics_1.default.closePunchWorkflow();
        const path = `${consts_1.ATOZ_FEATURE_PATH.TIME_CARD}`;
        location.assign(path);
    };
    const onBack = () => {
        BIAnalytics_1.default.clickBackInPunchWorkflow();
        setShowErrorFallback(false);
        setIsActionable(true);
    };
    const onContinue = () => {
        BIAnalytics_1.default.clickContinueInPunchWorkflow();
    };
    const onBackSummary = status !== Shared_1.ToastIconStatus.success
        ? () => {
            setIsShowSummary(false);
        }
        : undefined;
    const renderSummaryContent = action === PunchWorkflowTypes_1.PUNCH_WORKFLOW_ACTIONS.ADD && status === Shared_1.ToastIconStatus.error
        ? () => react_1.default.createElement(ErrorPerson_web_1.ErrorPerson, null)
        : undefined;
    const stepConfig = PunchWorkflowConfig_1.workflowConfigs[action] || PunchWorkflowConfig_1.workflowConfigs.default;
    return (react_1.default.createElement(context_1.PunchWorkflowContextProvider, { punchWorkflowInitial: {
            associateInfo,
            featureGates,
            selectedDateTime,
            isActionable,
            selectedPunchList,
            action,
            selectedPunchTime,
            newPunchTime,
            newPunchDate,
            useMilitaryTime,
            addPunchLockedOutStatus,
            editPunchLockoutStatus,
            showErrorFallback,
            payPeriodBreakdownInfo,
            punchesForMealLockoutValdn,
            isSubmitting,
            setCurrentStepTitle,
            setIsCurrentStepValid,
            setSelectedDateTime,
            setTotalSteps,
            setIsActionable,
            setSelectedPunchList,
            setAction,
            setSelectedPunchTime,
            setNewPunchTime,
            setNewPunchDate,
            setUseMilitaryTime,
            setAddPunchLockedOutStatus,
            setEditPunchLockoutStatus,
            setShowErrorFallback,
            setPayPeriodBreakdownInfo,
            setPunchesForMealLockoutValdn
        } },
        react_1.default.createElement(View_1.View, { dataTestId: PunchWorkflowTypes_1.PUNCH_WF_DATA_TEST_IDS.PUNCH_WORKFLOW, width: '100%', margin: 'auto', maxWidth: '842px' },
            react_1.default.createElement(StyledCard, null, !isShowSummary ? (react_1.default.createElement(Shared_1.WorkflowStepsContainer, { currentStepTitle: currentStepTitle, currentStep: currentStep, setCurrentStep: setCurrentStep, totalSteps: totalSteps, isActionable: isActionable, isCurrentStepValid: isCurrentStepValid, showErrorFallback: showErrorFallback, onSubmit: onSubmit, onClose: onClose, onBack: onBack, onContinue: onContinue, submitButtonAriaLabel: 'time_and_attendance_PunchWorkflow_Submit_A11y', progressTrackerAriaLabel: 'time_and_attendance_PunchWorkflow_StepProgress', closeButtonAriaLabel: 'time_and_attendance_PunchWorkflow_Close_A11y' }, stepConfig.steps[currentStep - 1].renderStepComp())) : (react_1.default.createElement(Shared_1.WorkflowSummary, { dataTestId: PunchWorkflowTypes_1.PUNCH_WF_DATA_TEST_IDS.PUNCH_WORKFLOW_SUMMARY, status: status, title: summaryTitle, supportingText: supportingText, detailsTitle: detailsTitle, detailsSubText: detailsSubText, detailsNote: detailsNote, onClose: onClose, onBack: onBackSummary, renderSummaryContent: renderSummaryContent, closeButtonAriaLabel: 'time_and_attendance_PunchWorkflow_Close_A11y' }))))));
};
exports.PunchWorkflow = PunchWorkflow;
const StyledCard = (0, Theme_1.styledWithTheme)(Card_1.Card)(`
   display:flex;
   flex-direction: column;
   border: none;
`);
